import { Tooltip } from "@mui/material";
import { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import useWindowDimensions from "@/hooks/useWindowDimensions";

export const TableHeader = memo(
    ({ title, description, Component }: { Component?: FC; title: string; description?: string }) => {
        const { t } = useTranslation();
        const { size } = useWindowDimensions();

        return (
            <Tooltip title={t((size.md ? description : title) || "")}>
                <div className="flex items-center  gap-1  font-medium text-gray-700 justify-start ">
                    {!!Component && <Component />}
                    {size.md && t(title || "")}
                </div>
            </Tooltip>
        );
    }
);
